var Modal = require('../modalUtilities');

function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDiseble() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
};

function csOpeningHours() {
    var $CsOpeningHours = $('.js-cs-openinghours');
    var csurl = $CsOpeningHours.data('url');
    $.ajax({
        url: csurl,
        type: 'get',
        success: function (data) {
            if (data.enableInThisCountry) {
                $CsOpeningHours.fadeIn();
            } else {
                $CsOpeningHours.fadeOut();
            }
        },
        error: function () {
            $CsOpeningHours.fadeOut();
        }
    });
};

function phoneIntegration () {
    var $phoneHeader = $('.js-phone-header');
    var url = $phoneHeader.data('url');
    $.ajax({
        url: url,
        type: 'get',
        success: function (data) {
            if (data.enableInThisCountry) {
                $phoneHeader.attr('href', 'tel:' + data.value);
            } else {
                $phoneHeader.remove();
            }
        },
        error: function () {
            $phoneHeader.remove();
        }
    });
};

module.exports = function () {
    // open modal on click to return open link
    $('body').on('click', '.js-go-to-order-return', function (e) {
        e.preventDefault();
        let modalTarget = e.currentTarget.dataset.target;
        let modal = new Modal(modalTarget);
        modal.open();
        liveChatDiseble();
        $(document).trigger('whatsappIntegration');
        phoneIntegration();
        csOpeningHours();
        if (navigator.userAgent.indexOf('Firefox') !== -1) {
            var heightFooter = $('.cc-returnopen-footer').height();
            $('.cc-returnopen-content').css({ 'padding-bottom': heightFooter });
        }
    });

    // close modal onclick
    $('body').on('click', '.js-close', function(e) {
        e.preventDefault();
        let modalTarget = $('.js-go-to-order-return').data('target');
        let modal = new Modal(modalTarget);
        modal.close();
        liveChatEnable();
    });

    // goes to return page
    $('body').on('click', '.js-gotoreturnopen', function (e) {
        e.preventDefault();
        $.spinner().start();

        var $form = $('#gotoreturnopen-form');
        var selectedProducts = getSelectedProducts();

        if ($form.length > 0 && selectedProducts.length > 0) {
            $('.js-selectedproducts').val(selectedProducts);
            $form.submit();
        } else $('.js-gotoreturnopen-error').removeClass('d-none');

        $.spinner().stop();
    });

    $('body').on('change', '.js-products-checkbox', function (e) {
        var selectedProducts = getSelectedProducts();
        if (selectedProducts.length > 0) {
            if ($('.js-gotoreturnopen-error').hasClass('d-none')) {
                $('.js-gotoreturnopen-error').addClass('d-none');
            };
            //$('.js-gotoreturnopen').removeAttr('disabled');
        } else {
            $('.js-gotoreturnopen-error').removeClass('d-none');
            //$('.js-gotoreturnopen').attr('disabled', 'disabled');
        }
    });

    $('body').on('click', '.js-go-to-order-return-from-list', function (e) {
        e.stopPropagation();
        var orderID = $(this).data('orderid');
        var orderToken = $(this).data('token');
        var orderDetailUrl = $(this).data('url');
        e.preventDefault();
        $.spinner().start();
        $.ajax({
            url: orderDetailUrl,
            data: {
                orderNo: orderID,
                token: orderToken
            },
            method: 'GET',
            success: function (response) {
                $('.js-order-detail').empty().html(response);
                $('.cc-custom-list').children('.cc-menu-text').each(function () {
                    if ($(this).attr('tabid') !== 'order') {
                        $(this).removeClass('cc-selected-menu');
                    } else {
                        $(this).addClass('cc-selected-menu');
                    }
                });
                $('.cc-dashboard-left-container').children('.tab-content').children('.tab-pane').each(function () {
                    if ($(this).attr('id') !== 'order') {
                        $(this).removeClass('active');
                    } else {
                        $(this).addClass('active');
                    }
                });
                $('.js-order-list-container').addClass('d-none');
                $('.js-order-detail ').removeClass('d-none');
                $('.js-main-subtitle-dashboard').text('');
                $(document).trigger('whatsappIntegration');
                phoneIntegration();
                csOpeningHours();
                $.spinner().stop();
                $('.js-go-to-order-return').click();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    function getSelectedProducts() {
        var selectedProducts = [];
        var selectedCheckBox = $('.cc-content-checkbox-return input.cc-checkbox:checked');
        for (var i = 0; i < selectedCheckBox.length; i++) {
            var $element = selectedCheckBox.eq(i);
            selectedProducts.push(parseInt($element.data('multi-quantity-position')));
        }
        return selectedProducts;
    }
};
